export const NAMESPACE = "PortalPage";

export const PAGE_ACTIONS = {
  OPEN_LINK: "open-link",
  OPEN_ALERT: "open-alert",
  OPEN_SESSION: "open-session"
};

export const NUMBER_OF_VIDEOS = 4;
